import { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

const BANNER_DISMISSED_KEY = 'wren_domain_banner_dismissed';

export const DomainChangeBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Only show to returning users who haven't dismissed the banner
    const isDismissed = localStorage.getItem(BANNER_DISMISSED_KEY);
    const hasExistingData = localStorage.getItem('cashee_expenses') || 
                            localStorage.getItem('cashee_budget') ||
                            localStorage.getItem('cashee_onboarding_complete');
    
    if (!isDismissed && hasExistingData) {
      // Small delay to not interrupt initial load
      const timer = setTimeout(() => setIsVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleDismiss = () => {
    setIsVisible(false);
    localStorage.setItem(BANNER_DISMISSED_KEY, 'true');
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          transition={{ duration: 0.3 }}
          className="fixed top-0 left-0 right-0 z-50 bg-primary/95 text-primary-foreground px-4 py-2.5 text-center text-sm backdrop-blur-sm"
        >
          <div className="flex items-center justify-center gap-2">
            <span>
              <span className="font-medium">We've rebranded!</span>
              {' '}Cashee is now <span className="font-semibold">Wren</span> at app.trywren.app
            </span>
            <button
              onClick={handleDismiss}
              className="ml-2 p-1 rounded-full hover:bg-primary-foreground/20 transition-colors"
              aria-label="Dismiss banner"
            >
              <X className="h-4 w-4" />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
